import { HOME_PAGE_ID } from '_/common/routes/routes.constants';
import { IFlow } from '_/features/flows/common/types/flow.types';
import { getFlowUrl } from '_/features/flows/common/utils/flowUrl.utils';
import { setFlowType } from '_/features/flows/common/utils/flowUtils';
import { IFlowListRow } from '_/features/flows/list/flowList.types';
import { formatWrittenDate } from '_/utils/dateUtils';

export const flowListAdapter = (items: IFlow[], orgSlug: string, projectSlug: string): IFlowListRow[] =>
  items.map((item) => {
    const { slug } = item;

    const flowUrl = getFlowUrl({
      flowSlug: slug,
      orgSlug: orgSlug,
      projectSlug: projectSlug,
    });

    return {
      ...item,
      createdOn: formatWrittenDate(item.addedAt),
      href: `${flowUrl}/${HOME_PAGE_ID}`,
      calcType: setFlowType(item),
    };
  });
